module.exports = __webpack_public_path__ + "static/media/icon_schedule_message_blue.4500d66a.svg";